<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt1"><span class="epub-bi">Part One</span></p>
<p class="pt"><span class="epub-b">FIRST INTO THE GREAT BASIN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?84cc030e